module.exports = "query CustomersByPhoneQuery($terms:String!){customers(search:$terms){edges{node{id name user{id username firstName lastName rowId}}}}}"